import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RiArrowRightSLine } from "react-icons/ri";
import {
  getRequest,
  putRequest,
  putWithFormData,
} from "../../helpers/api.helper";
import { getSessionItem } from "../../helpers/function.helper";
import { ChevronRight } from "lucide-react";
import { StepPropsType } from "../../types";
import { useLanguage } from "../../context/LanguageContext";
import { EMPLOYMENT_OPTIONS } from "../../utils/employmentOptions";

type DropdownValue = {
  value: string;
  label: string;
};

type Step4SelectedOptions2 = {
  Education?: DropdownValue;
  Employment_Status: DropdownValue;
  occupation?: DropdownValue;
  Anuual_Income: DropdownValue;
  Job_Location?: DropdownValue;
  Any_Other_Bussiness?: DropdownValue;
  Other_Business_Income?: DropdownValue;
};

const Step4 = ({
  bureauId,
  setCurrentStep,
  currentStep,
  steps,
  profileId,
  setCompletedSteps,
}: StepPropsType) => {
  // Function to randomly select 10 skills from the available skills
  const getRandomSkills = (skillsArray: any, count = 10) => {
    if (!skillsArray || skillsArray.length === 0) return [];
    const shuffled = [...skillsArray].sort(() => 0.5 - Math.random());
    return shuffled
      .slice(0, Math.min(count, skillsArray.length))
      .map((skill) => skill.skill);
  };
  const { t } = useLanguage();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [searchTerm3, setSearchTerm3] = useState("");
  const [modalData, setModalData] = useState<any>(null);
  const [modalData2, setModalData2] = useState<any>(null);
  const [modalData3, setModalData3] = useState<any>(null);

  const [city, setCity] = useState([]);
  const [education, setEducation] = useState([]);
  const [annualIncome, setAnnualIncome] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [extraSkills, setExtraSkills] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState<any>({
    Business_Location: [], // Default for languages known (can be multiple)
  });

  const [selectedOptions3, setSelectedOptions3] = useState<any>({
    extraSkills: [], // Default for languages known (can be multiple)
  });
  const [selectedOptions2, setSelectedOptions2] = useState<any>({
    Employment_Status: {
      value: "privateEmployee",
      label: "Private Employee",
    },
  });

  const dropdownOptions: any = {
    Business_Location: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],
  };
  const dropdownOptions3: any = {
    extraSkills: [
      ...extraSkills.map((skill: any) => ({
        value: skill.skill,
        label: skill.skill,
      })),
    ],
  };
  const dropdownOptions2: any = {
    Education: [
      ...education.map((education: any) => ({
        value: education.education,
        label: education.education,
      })),
    ],
    Employment_Status: EMPLOYMENT_OPTIONS,
    occupation: [
      ...occupation.map((occupation: any) => ({
        value: occupation.occupation,
        label: occupation.occupation,
      })),
    ],
    Anuual_Income: [
      ...annualIncome.map((annual_income: any) => ({
        value: annual_income.annual_income,
        label: annual_income.annual_income,
      })),
    ],
    Job_Location: [
      ...city.map((job_location: any) => ({
        value: job_location.city,
        label: job_location.city,
      })),
    ],

    Any_Other_Bussiness: [
      { value: "", label: "Select Business" }, // Placeholder option
      { value: "null", label: "None" },
      { value: "1", label: "1" },
      { value: "2", label: "2" },
      { value: "3", label: "3" },
      { value: "4", label: "4" },
    ],
    Other_Business_Income: [
      ...annualIncome.map((business_income: any) => ({
        value: business_income.annual_income,
        label: business_income.annual_income,
      })),
    ],
  };

  const handleSelect = (selectedOption2: any) => {
    setSelectedOptions2({
      ...selectedOptions2,
      [modalData2.key]: selectedOption2,
    });
    closeModal2();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRequest("/common/profile/step4");
        if (response.success) {
          setCity(response.data.city);
          setEducation(response.data.education);
          setAnnualIncome(response.data.annual_income);
          setOccupation(response.data.occupation);
          setExtraSkills(response.data.extra_skills);
        }
      } catch (error) {
        console.error(`Error fetching data:`, error);
      }
    };
    fetchData();
  }, []);

  // Set random 10 extra skills as default after data is fetched
  useEffect(() => {
    if (extraSkills.length > 0) {
      const randomSkills = getRandomSkills(extraSkills, 10);
      setSelectedOptions3((prev: any) => ({
        ...prev,
        extraSkills: randomSkills,
      }));
    }
  }, [extraSkills]);

  const openModal = (key: any) =>
    setModalData({ key, options: dropdownOptions[key] });
  const closeModal = () => setModalData(null);

  const openModal2 = (key: any) =>
    setModalData2({ key, options: dropdownOptions2[key] });
  const closeModal2 = () => setModalData2(null);

  const openModal3 = (key: any) =>
    setModalData3({ key, options: dropdownOptions3[key] });
  const closeModal3 = () => setModalData3(null);

  useEffect(() => {
    if (modalData) {
      setSearchTerm(""); // Reset search term when opening a new modal
    }
  }, [modalData]);

  useEffect(() => {
    if (modalData2) {
      setSearchTerm2(""); // Reset search term when opening a new modal
    }
  }, [modalData2]);

  useEffect(() => {
    if (modalData3) {
      setSearchTerm3(""); // Reset search term when opening a new modal
    }
  }, [modalData3]);

  const handleCheckboxChange = (event: any, option: any) => {
    const { checked } = event.target;
    const updatedSelectedOptions = checked
      ? [...selectedOptions.Business_Location, option.value]
      : selectedOptions.Business_Location.filter(
          (lang: any) => lang !== option.value,
        );

    setSelectedOptions({
      ...selectedOptions,
      Business_Location: updatedSelectedOptions,
    });
  };

  const handleCheckboxChange2 = (event: any, option: any) => {
    const { checked } = event.target;
    const updatedSelectedOptions3 = checked
      ? [...selectedOptions3.extraSkills, option.value]
      : selectedOptions3.extraSkills.filter(
          (skill: any) => skill !== option.value,
        );
    setSelectedOptions3({
      ...selectedOptions3,
      extraSkills: updatedSelectedOptions3,
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top
  }, []);

  useEffect(() => {
    if (!profileId) return;

    // ⚠️ wait until master data is loaded
    if (
      !city.length ||
      !education.length ||
      !annualIncome.length ||
      !occupation.length ||
      !extraSkills.length
    ) {
      return;
    }

    const fetchStep4Data = async () => {
      try {
        const res = await getRequest(`/bureau/profile/${profileId.martialId}`);
        if (!res?.data) return;

        const data = res.data;

        setSelectedOptions2((prev: any) => ({
          ...prev,

          Education: data.education
            ? { value: data.education, label: data.education }
            : prev.Education,

          Employment_Status:
            dropdownOptions2.Employment_Status.find(
              (opt: any) => opt.value === data.employmentStatus,
            ) || prev.Employment_Status,

          occupation: data.occupation
            ? { value: data.occupation, label: data.occupation }
            : prev.occupation,

          Anuual_Income: data.annualIncome
            ? { value: data.annualIncome, label: data.annualIncome }
            : prev.Anuual_Income,

          Job_Location: data.jobLocation
            ? { value: data.jobLocation, label: data.jobLocation }
            : prev.Job_Location,

          Any_Other_Bussiness: data.otherBusiness
            ? { value: data.otherBusiness, label: data.otherBusiness }
            : prev.Any_Other_Bussiness,

          Other_Business_Income: data.otherBusinessIncome
            ? {
                value: data.otherBusinessIncome,
                label: data.otherBusinessIncome,
              }
            : prev.Other_Business_Income,
        }));

        setSelectedOptions({
          Business_Location: Array.isArray(data.businessLocation)
            ? data.businessLocation
            : [],
        });

        setSelectedOptions3({
          extraSkills: Array.isArray(data.extraTalentedSkills)
            ? data.extraTalentedSkills
            : [],
        });
      } catch (err) {
        console.error("Failed to load Step4 data", err);
      }
    };

    if (bureauId) fetchStep4Data();
  }, [
    profileId,
    city.length,
    education.length,
    annualIncome.length,
    occupation.length,
    extraSkills.length,
  ]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (
      !selectedOptions2.Education ||
      !selectedOptions2.Employment_Status ||
      !selectedOptions2.occupation ||
      !selectedOptions2.Anuual_Income
    ) {
      alert(
        "Education, Employment Status, Occupation and Annual Income are mandatory.",
      );
      return;
    }

    // Create formattedOptions, allowing empty values
    const formattedOptions = {
      education: selectedOptions2.Education?.value || "",
      employmentStatus: selectedOptions2.Employment_Status?.value || "",
      occupation: selectedOptions2.occupation?.value || "",
      annualIncome: selectedOptions2.Anuual_Income?.value || "",
      jobLocation: selectedOptions2.Job_Location?.value || "",
      otherBusinessIncome: selectedOptions2.Other_Business_Income?.value || "",
      otherBusiness: selectedOptions2.Any_Other_Bussiness?.value || "",
    };

    const dataToSend = {
      ...formattedOptions,
      extraTalentedSkills: selectedOptions3.extraSkills || "",
      businessLocation: selectedOptions.Business_Location || "",
      step1: 1,
      step2: 1,
      step3: 1,
      step4: 1,
    };

    try {
      const response = await putRequest(
        `/bureau/profile/${profileId?.userId}`,
        dataToSend,
      );

      if (response.success) {
        setCompletedSteps?.((prev) =>
          prev.includes(currentStep) ? prev : [...prev, currentStep],
        );
        if (currentStep < steps.length) {
          setCurrentStep(currentStep + 1);
        }
      } else {
        alert("Failed to update details.");
      }
    } catch (error: any) {
      console.error("Error updating details:", error.message); // Log specific error message
      alert("An error occurred while updating details.");
    }
  };

  return (
    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg">
      <div className="space-y-6 py-4 px-3 z-99">
        {/* second objects */}
        {Object.keys(dropdownOptions2).map((key) => {
          const requiredFields = [
            "Education",
            "Employment_Status",
            "occupation",
            "Anuual_Income",
          ];
          return (
            <>
              <div className="mb-[-20px]">
                <label className="block text-red-500 font-medium mb-2">
                  {t(key.replace(/_/g, " "))}
                  {requiredFields.includes(key) && (
                    <span className="text-red-600 ml-1">*</span>
                  )}
                </label>
              </div>

              <div
                key={key}
                className="flex flex-col w-full border px-3 border-gray-300 py-3 cursor-pointer rounded-lg hover:shadow-lg transition-all"
                onClick={() => openModal2(key)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-gray-500 text-md font-medium">
                    {selectedOptions2[key]?.label || `Select ${key}`}
                  </span>
                  <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
                </div>
              </div>
            </>
          );
        })}

        {/* Second objects 2 */}
        {Object.keys(dropdownOptions).map((key) => (
          <div key={key} className="mb-[-20px] rounded-lg">
            <label className="block text-red-500 font-medium mb-2 capitalize">
              {t(key)}
            </label>

            <div
              className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
              onClick={() => openModal(key)}
            >
              <div className="flex items-center justify-between rounded">
                <span className="text-gray-500 text-md font-medium">
                  {selectedOptions[key]?.length
                    ? dropdownOptions[key]
                        .filter((opt: any) =>
                          selectedOptions[key].includes(opt.value),
                        )
                        .map((lang: any) => lang.label)
                        .join(", ")
                    : `Select ${key}`}
                </span>
                <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
              </div>
            </div>
          </div>
        ))}

        {Object.keys(dropdownOptions3).map((key) => (
          <div key={key} className="mb-[-20px] rounded-lg">
            <label className="block text-red-500 font-medium mb-2 capitalize">
              {t(key)}
            </label>

            <div
              className="flex flex-col w-full border px-3 border-gray-300 py-3 rounded-lg cursor-pointer hover:shadow-lg transition-all"
              onClick={() => openModal3(key)}
            >
              <div className="flex items-center justify-between rounded">
                <span className="text-gray-500 text-md font-medium">
                  {selectedOptions3[key]?.length
                    ? dropdownOptions3[key]
                        .filter((opt: any) =>
                          selectedOptions3[key].includes(opt.value),
                        )
                        .map((skill: any) => skill.label)
                        .join(", ")
                    : `Select ${key}`}
                </span>
                <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
              </div>
            </div>
          </div>
        ))}

        {/* Add other fields similarly */}
        {/* <button
          type="submit"
          className="w-full bg-red-600 text-white p-3 rounded-lg hover:bg-red-800"
        >
          onSubmit={handleSubmit}
          Submit
        </button> */}

        {/* Action Buttons */}
        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-6">
          {/* <button
            onClick={() => {
              setCurrentStep(Math.max(1, currentStep - 1));
            }}
            className="flex-1 px-6 py-3.5 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
          >
            Previous
          </button> */}
          <button
            onClick={handleSubmit}
            className="flex-1 px-6 py-3.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-semibold hover:from-pink-600 hover:to-purple-700 transition-all shadow-lg"
          >
            {currentStep === steps.length ? t("Submit") : t("Next Step")}
          </button>
        </div>
      </div>
      {/* Modal for Selecting Languages */}
      {modalData && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center  items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {modalData.key}
            </h2>

            {/* "Select All" Checkbox */}
            {/* <div className="flex items-center space-x-2 mb-4">
                <input
                  id="selectAllCheckbox"
                  type="checkbox"
                  checked={
                    selectedOptions.languagesKnown.length ===
                    dropdownOptions.languagesKnown.length
                  }
                  onChange={handleSelectAllChange}
                  className="form-checkbox h-4 w-4 text-red-600"
                />
                <label className="block text-gray-700">Select All</label>
              </div> */}

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData.key}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData.options
                .filter((option: any) =>
                  option.label.toLowerCase().includes(searchTerm.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <>
                    <div key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={selectedOptions.Business_Location.includes(
                          option.value,
                        )}
                        onChange={(e) => handleCheckboxChange(e, option)}
                        className="form-checkbox h-4 w-4 text-red-600"
                      />
                      <label className="block text-gray-700 py-3">
                        {option.label}
                      </label>
                    </div>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
      {/* Modal for Selecting Options */}
      {modalData2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {modalData2.key}
            </h2>

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData2.key}`}
              value={searchTerm2}
              onChange={(e) => setSearchTerm2(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData2.options
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm2.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <div key={index}>
                    <button
                      className="block w-full text-left px-4 py-3 hover:bg-gray-100 transition"
                      onClick={() => handleSelect(option)}
                    >
                      {option.label}
                    </button>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </div>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal2}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}

      {modalData3 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center  items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {modalData3.key}
            </h2>

            {/* "Select All" Checkbox */}
            {/* <div className="flex items-center space-x-2 mb-4">
                <input
                  id="selectAllCheckbox"
                  type="checkbox"
                  checked={
                    selectedOptions.languagesKnown.length ===
                    dropdownOptions.languagesKnown.length
                  }
                  onChange={handleSelectAllChange}
                  className="form-checkbox h-4 w-4 text-red-600"
                />
                <label className="block text-gray-700">Select All</label>
              </div> */}

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData3.key}`}
              value={searchTerm3}
              onChange={(e) => setSearchTerm3(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData3.options
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm3.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <>
                    <div key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={selectedOptions3.extraSkills.includes(
                          option.value,
                        )}
                        onChange={(e) => handleCheckboxChange2(e, option)}
                        className="form-checkbox h-4 w-4 text-red-600"
                      />
                      <label className="block text-gray-700 py-2">
                        {option.label}
                      </label>
                    </div>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal3}
            >
              {t("Continue")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step4;
